"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-left", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M26 21v5l-16-7.5L26 12v5h11.375v4H26z", fill: "#4C4C4C" }),
            _react2.default.createElement("path", { d: "M19 37.5C8.783 37.5.5 29.217.5 19S8.783.5 19 .5 37.5 8.783 37.5 19 29.217 37.5 19 37.5z", stroke: "#BBB" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-arrow-left.js
// module id = 1829
// module chunks = 0